export default __webpack_public_path__ + "static/5-7b695959bebd6bab7606dbb54b62aae1.jpg";